import React from 'react';

type DeliveryManagementTab = 'manage-routes' | 'booking-details';

interface Tab {
  key: DeliveryManagementTab;
  label: string;
  icon: React.ComponentType<any>;
  color: string;
}

interface DeliveryManagementTabsProps {
  tabs: Tab[];
  activeTab: DeliveryManagementTab;
  onTabChange: (tab: DeliveryManagementTab) => void;
}

export const DeliveryManagementTabs: React.FC<DeliveryManagementTabsProps> = ({
  tabs,
  activeTab,
  onTabChange
}) => {
  return (
    <div className="mb-6">
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Delivery Management Tabs">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.key;
            const Icon = tab.icon;
            
            return (
              <button
                key={tab.key}
                onClick={() => onTabChange(tab.key)}
                className={`
                  whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm 
                  flex items-center space-x-2 transition-colors
                  ${isActive
                    ? `border-${tab.color}-500 text-${tab.color}-600`
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }
                `}
              >
                <Icon className="w-5 h-5" />
                <span>{tab.label}</span>
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};
